/***
 * Created on 2023/8/21
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
import {useTranslation} from "react-i18next";
import EmpyTrustedDevice from "./empy_trusted_device";
import ManageTrustedDevice from "./manage_trusted_device";
import {useQuery} from "@tanstack/react-query";
import {apiGet} from "../../../../service/api";
import {UAParser} from "ua-parser-js";

function TrustedDevice(props) {
    const { t } = useTranslation();

    const showDomain = (data) => {
        if (data?.domain?.toLowerCase().indexOf('cn') > 0) {
            return t('@China@');
        }
        return t('@Global@');
    }

    const trusted_devices = useQuery({
        queryKey: ['get_trusted_device'],
        queryFn: async () => {
            const data = await apiGet(`/ajax/trust_devices`);
            for (let rec of data) {
                const agent = new UAParser(rec?.user_agent).getResult();
                rec.display_device_name = data?.device?.device_model || (agent?.os?.name || agent?.browser?.name ? `${agent?.os?.name} ${agent?.os?.browser?.name || ""} ${agent?.os?.browser?.version || ""}` : agent?.ua);
                rec.name = data?.device?.device_hostname ? data.device.device_hostname : data.client_name  || '----';
                rec.display_domain = showDomain(rec);
            }
            return data;
        }
    });

    return (
        <>
            { !trusted_devices?.data && <EmpyTrustedDevice /> }
            { trusted_devices?.data && <ManageTrustedDevice data={trusted_devices.data}/> }
        </>

    );
}

export default TrustedDevice;